module.exports = __webpack_public_path__ + "img/bed7a24.png";